<template>
  <div>
    <other-banner :BannerType="'联系我们'"></other-banner>
    <div class="content_box">
      <div class="title">
        <title-nav :zhName="$route.name" :enName="$route.meta.cate"></title-nav>
      </div>
      <div class="cutr_content">
        <div class="bootom_caser">
          <div class="content_item">
            <div class="zh">公司总机</div>
            <div class="en">COMPANY SWITCHBOARD</div>
            <img class="icon" src="../assets/concate/phone.png">
            <div class="phones">{{ config.company_tel }}</div>
          </div>
          <div class="content_item box_center">
            <div class="zh">不良反应联系电话</div>
            <div class="en">CONTACT NUMBER OF ADVERSE REACTIONS</div>
            <img class="icon" src="../assets/concate/phone.png">
            <div class="phones">{{ config.feedback_tel }}</div>
          </div>
          <div class="content_item">
            <div class="zh">公司传真</div>
            <div class="en">COMPANY FAX</div>
            <img class="icon" src="../assets/concate/fax.png">
            <div class="phones">{{ config.fax }}</div>
          </div>
        </div>
        <div class="title_tips">
          <div class="names">公司地址</div>
          <div class="lines"></div>
        </div>
        <div class="map_bottom">
          <div class="maps">
            <baidu-map
                class="map"
                ak="8BB7F0E5C9C77BD6B9B655DB928B74B6E2D838FD"
                :center="center"
                :zoom="zoom"
                :marker="center"
            ><bm-marker key="marker.code" :position="center"></bm-marker>
            </baidu-map>
          </div>
          <div class="tab_address">
            <div class="address" @click="changAddress(index)" :class="{'active_add':case_index==index}" v-for="(item,index) in address" :key="index">
              <img class="active_add_img" src="../assets/concate/addre.png">
              <img class="active_add_img_acs" src="../assets/concate/addresele.png">
              <div class="names_op one-txt-line">{{item.name}}</div>
              <div class="line"></div>
              <div class="srreds one-txt-line">{{item.address}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import OtherBanner from "../components/otherBanner";
import TitleNav from "../components/titleNav";
import {getConfig, getAddressList} from "../api/apis";
import {BaiduMap,BmMarker} from 'vue-baidu-map'
export default {
  name: "product",
  components: {
    BmMarker,
    BaiduMap,
    TitleNav,
    OtherBanner,
  },
  data() {
    return {
      address: [],
      config: {},
      case_index: 0,
      center: { lng:104.04034, lat: 30.61533 }, // //经纬度
      zoom: 15 // //地图展示级别
    }
  },
  mounted() {
    this.GetAddressList()
    this.GetConfig()
  },
  methods: {
    changAddress(e){
      this.case_index = e
      this.center.lng  = this.address[e].lng
      this.center.lat  = this.address[e].lat
    },
    GetAddressList() {
      getAddressList().then(res => {
        this.address = res.data
        if(res.data.length){
          this.center.lng  = res.data[0].lng
          this.center.lat  = res.data[0].lat
        }
      })
    },
    GetConfig() {
      getConfig().then(res => {
        this.config = res.data
      })
    }
  }

}
</script>

<style scoped lang="less">
.content_box {
  width: 1200px;
  margin: 0 auto;
  cursor: pointer;

  .title {
    margin: 100px auto 55px;
  }

  .cutr_content {
    cursor: pointer;
    margin-top: 50px;
    margin-bottom: 120px;

    .bootom_caser {
      display: flex;

      .content_item {
        width: 389px;
        height: 132px;
        text-align: center;

        .zh {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1A1A1A;
        }

        .en {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #909090;
          margin: 10px auto 20px;
        }

        .icon {
          width: 26px;
          height: 26px;
          margin-bottom: 19px;
        }

        .phones {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }

      .box_center {
        width: 442px;
        border-right: 1px solid #404040;
        border-left: 1px solid #404040;
      }


    }
    .title_tips {
      width: 160px;
      margin: 100px auto 60px;

      .names {
        font-size: 38px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #1A1A1A;
      }

      .lines {
        width: 64px;
        height: 4px;
        background: #2C7BE5;
        margin: 20px auto 0;
      }
    }

    .map_bottom{
      display: flex;
      justify-content: space-between;
      min-height: 657px;
      .maps{
        width: 702px;
        height: 657px;
        .map {
          width:100%;
          height:100%;
        }
      }
      .tab_address{
        width: 458px;
        .address{
          width: 100%;
          height: 199px;
          text-align: center;
          background: #FFFFFF;
          border: 1px solid #E3E3E3;
          padding-top: 0.1px;
          margin-bottom: 30px;
          img{
            width: 36px;
            height: 46px;
            margin-top: 26px;
          }
          .names_op{
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1A1A1A;
            margin-top: 10px;
          }
          .line{
            width: 60px;
            height: 0px;
            border: 1px solid #2C7BE5;
            margin:10px auto 20px;
          }
          .srreds{
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #4D4D4D;
          }
          .active_add_img{
            display: none;
          }
          .active_add_img_acs{
            display: inline-block;
          }
        }
        .address:hover{
          background: #0092DD;
          box-shadow: 0px 4px 10px rgba(9, 122, 216, 0.2);
          .names_op,.srreds{
            color: #FFFFFF;
          }
          .line{
            border-color: #FFFFFF;
          }
          .active_add_img{
              display: inline-block;
          }
          .active_add_img_acs{
            display: none;
          }
        }
        .active_add{
          background: #0092DD;
          box-shadow: 0px 4px 10px rgba(9, 122, 216, 0.2);
          .names_op,.srreds{
            color: #FFFFFF;
          }
          .line{
            border-color: #FFFFFF;
          }
          .active_add_img{
            display: inline-block;
          }
          .active_add_img_acs{
            display: none;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .content_box {
    width: auto;
    padding: 0.1px 15px 0;

    .title {
      margin: 26px auto 11px;
    }

    .cutr_content {
      margin-top: 21px;
      .bootom_caser {
        display: flex;
        flex-wrap: wrap;
        .content_item {
          width: 100%;
          height: auto;
          text-align: center;
          margin-bottom: 20px;
          .zh {
            font-size: 13px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1A1A1A;
          }

          .en {
            font-size: 9px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #909090;
            margin: 9px auto 18px;
          }

          .icon {
            width: 19px;
            height: 19px;
            margin-bottom: 16px;
          }

          .phones {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
          }
        }
        .box_center {
          width: 100%;
          border: none;
          position: relative;
          padding: 20px 0;
        }
        .box_center::after{
          position: absolute;
            content: '';
          width: 86px;
          height: 0px;
          border: 1px solid #404040;
          opacity: 1;
          left: 50%;
          top: 0px;
          transform: translateX(-50%);
        }
        .box_center::before{
          position: absolute;
          content: '';
          width: 86px;
          height: 0px;
          border: 1px solid #404040;
          opacity: 1;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0px;
        }


      }
      .title_tips {
        width: 160px;
        margin: 35px auto 26px;

        .names {
          font-size: 19px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1A1A1A;
          text-align: center;
        }

        .lines {
          width: 23px;
          height: 2px;
          background: #2C7BE5;
          margin: 10px auto 0;
        }
      }

      .map_bottom{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        min-height: auto;
        .maps{
          width: 100%;
          height: 323px;
          margin-bottom: 17px;
          .map {
            width:100%;
            height:100%;
          }
        }
        .tab_address{
          width:100%;
          .address{
            width: 100%;
            height: 135px;
            text-align: center;
            background: #FFFFFF;
            border: 1px solid #E3E3E3;
            padding-top: 0.1px;
            margin-bottom: 9px;
            img{
              width: 24px;
              height: 31px;
              margin-top: 12px;
            }
            .names_op{
              font-size: 19px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #1A1A1A;
              margin-top: 8px;
            }
            .line{
              width: 41px;
              height: 0px;
              border: 1px solid #2C7BE5;
              margin:8px auto 12px;
            }
            .srreds{
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #4D4D4D;
            }
            .active_add_img{
              display: none;
            }
            .active_add_img_acs{
              display: inline-block;
            }
          }
          .address:hover{
            //background: #0092DD;
            //box-shadow: 0px 4px 10px rgba(9, 122, 216, 0.2);
            //.names_op,.srreds{
            //  color: #FFFFFF;
            //}
            //.line{
            //  border-color: #FFFFFF;
            //}
            //.active_add_img{
            //  display: inline-block;
            //}
            //.active_add_img_acs{
            //  display: none;
            //}
          }
          .active_add{
            background: #0092DD;
            box-shadow: 0px 4px 10px rgba(9, 122, 216, 0.2);
            .names_op,.srreds{
              color: #FFFFFF;
            }
            .line{
              border-color: #FFFFFF;
            }
            .active_add_img{
              display: inline-block;
            }
            .active_add_img_acs{
              display: none;
            }
          }
        }
      }

    }
  }
}
</style>